/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 3/11/2023
 */

import { Step, StepLabel, Stepper, Typography } from "@mui/material";
import styles from "./CheckoutSteps.module.css"

const CheckoutSteps = ({ activeStep, steps }) => {
  return (
    <div className={styles.container}>
      <Stepper alternativeLabel activeStep={activeStep} className={styles.stepper}>
        {steps.map(step => (
          <Step key={step}>
            <StepLabel className={styles.label}>
              {/* {step} */}
              </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  )
}

export default CheckoutSteps;